import { inject, Injectable } from "@angular/core";
import { ApiRequest, ApiService } from "./api.service";
import { firstValueFrom } from "rxjs";
import { ResponseDataModel } from "@core/models/response-data.model";
import { SKIP_LOADING } from "@core/consts/elusive-headers.constants";

@Injectable({
  providedIn: "root",
})
export class NotificationsTokensService {
  private readonly apiService: ApiService = inject(ApiService);

  public async createNotificationsToken(token: string): Promise<ResponseDataModel> {
    const request: ApiRequest = {
      route: "/users/me/notifications-tokens",
      body: { token },
      headers: SKIP_LOADING,
    };
    
    return await firstValueFrom(this.apiService.post<ResponseDataModel>(request));
  }
}
